import React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    transition: 'box-shadow 0.15s ease-in-out',
    '&:hover': {
      boxShadow: theme.shadows[4]
    }
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  icon: {
    color: (props) => {
      if (props.color === 'success') return theme.palette.success.main;
      if (props.color === 'error') return theme.palette.error.main;
      if (props.color === 'warning') return theme.palette.warning.main;
      return theme.palette.primary.main;
    },
    fontSize: 32,
    opacity: 0.9
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5
  },
  value: {
    fontSize: '2rem',
    fontWeight: 700,
    color: (props) => {
      if (props.color === 'success') return theme.palette.success.main;
      if (props.color === 'error') return theme.palette.error.main;
      if (props.color === 'warning') return theme.palette.warning.main;
      return theme.palette.primary.main;
    },
    lineHeight: 1.2,
    marginBottom: theme.spacing(0.5)
  },
  subtitle: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary
  }
}));

const StatsCard = ({ title, value, subtitle, icon, color = 'primary' }) => {
  const classes = useStyles({ color });
  
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Box className={classes.header}>
          <Typography className={classes.title}>
            {title}
          </Typography>
          {icon && <span className={classes.icon}>{icon}</span>}
        </Box>
        
        <Typography className={classes.value}>
          {value}
        </Typography>
        
        {subtitle && (
          <Typography className={classes.subtitle}>
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default StatsCard;
